<template lang="pug">
  form(@submit.prevent="next")
    p.text-large - Textos do Documento
    doc-textos(v-model="resource.textos" group="textos" label="texto" :editable="false")
    .pt-2
      .divider
      button.btn.btn-primary(:disabled="$v.resource.$invalid")
        btn-content(name="next")
</template>

<script>
import mixin from './mixin'
import { required, minLength } from 'vuelidate/lib/validators'

export default {
  mixins: [mixin],
  validations: {
    resource: {
      textos: {
        $each: {
          descricao: { required, minLength: minLength(10) },
        },
      },
    },
  },
}
</script>
